<!--
  SupplierLockedNotice — the ONE sentence a showroom-stage supplier reads wherever
  an active supplier would pull, answer or comment (supplier-showroom design
  Section 3 / 13). Copy is the owner-approved string `supplier.showroom.lock`; nothing
  else is said here. The server already refuses every write for this stage — this
  only replaces the controls with the reason. Tappable since supplier-messages
  P2-A: it opens the gains page (/join/gains/), where the meeting is asked for.
  An active supplier never sees it.
-->
<template>
  <button type="button" class="supplier-locked-notice" @click="openGains">
    <f7-icon f7="lock_fill" size="18"></f7-icon>
    <span class="supplier-locked-notice__text">{{ $t('supplier.showroom.lock') }}</span>
  </button>
</template>

<script setup>
import { f7 } from 'framework7-vue';

defineOptions({
  name: 'SupplierLockedNotice',
});

function openGains() {
  f7?.views?.main?.router?.navigate('/join/gains/');
}
</script>

<style scoped>
.supplier-locked-notice {
  width: calc(100% - 32px);
  font: inherit;
  text-align: start;
  cursor: pointer;
  border: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 12px 16px;
  padding: 12px 14px;
  border-radius: var(--poolit-radius-lg, 16px);
  background: var(--poolit-primary-50, #f5f0ff);
  color: var(--poolit-primary-700, #6621e2);
}

.supplier-locked-notice__text {
  margin: 0;
  font-size: 14px;
  font-weight: var(--poolit-font-weight-semibold, 600);
  line-height: 1.5;
}
</style>
